import { FlightsMultiPluralLocalizationTemplate } from 'types/shared';

// TODO COH-901 replacerString string should from token ,bug in COH tokens coming empty
export function flightsMultiPluralLocalizationTemplate(
  countVal: number,
  template: FlightsMultiPluralLocalizationTemplate,
  replacerString: string
) {
  let templateSelected = template.otherTemplate;
  switch (true) {
    case countVal === 0:
      templateSelected = template.zeroTemplate;
      break;
    case countVal === 1:
      templateSelected = template.oneTemplate;
      break;
    case countVal === 2:
      templateSelected = template.twoTemplate;
      break;
    case countVal > 2 && countVal <= 10:
      templateSelected = template.fewTemplate;
      break;
    case countVal > 10 && countVal < 100:
      templateSelected = template.manyTemplate;
      break;
    default:
  }

  return templateSelected.replace(replacerString, countVal.toString());
}
